<button on:click class="text-xl w-64 font-bold text-black bg-yellow-500 px-5 py-3 cursor-pointer"><slot/></button>

<style>
	button {
		font-family: 'Bakbak One';
	}
</style>